import type { CampaignCardStyles } from '~/ui/campaign-card';
import { tw } from '~/utils';

import { campaignLogoStyles, favoriteCampaignLogoStyles } from './campaign-logo';
import { favoriteSlot } from './favorite';

export const campaignListStyles = tw('mx-auto mb-16 grid w-fit grid-cols-4 gap-6 py-6 text-black md:grid-cols-6');
export const campaignSearchResultListStyles = tw('grid grid-cols-2 gap-2 pt-6 pb-12 md:grid-cols-5 lg:gap-4');

export const campaignCardStyles = tw<CampaignCardStyles>({
  box: 'border-grey-100 h-full gap-1 rounded-sm border-2 border-solid px-[7px] pt-6 pb-4 shadow-[0px_0px_15px_#dcdcdc]',
  layout: 'grid',
  name: 'text-body-s-bold m-2 line-clamp-1 text-center',
  logo: campaignLogoStyles,
  pointSlot: 'bg-grey-50 w-full rounded-sm px-1 py-2 text-center [.pointup-wrap_&]:bg-red-50',
  favoriteSlot: favoriteSlot,
});

export const favoriteCampaignCardStyles = tw<CampaignCardStyles>({
  box: 'border-grey-100 rounded-sm border p-4 px-[7px] shadow-[0px_0px_15px_#dcdcdc]',
  layout: 'grid place-items-center gap-2',
  name: 'text-body-s-bold line-clamp-1',
  logo: favoriteCampaignLogoStyles,
  pointSlot: 'mt-4 w-full',
});
